export const KANBAN_ACCESS_LEVELS = ['view', 'comment', 'edit'];

const ACCESS_RANK = {
  view: 1,
  comment: 2,
  edit: 3,
};

export const normalizeKanbanAccess = access => {
  const level = KANBAN_ACCESS_LEVELS.includes(access?.level)
    ? access.level
    : null;
  const rank = ACCESS_RANK[level] || 0;

  return {
    level,
    shared: access?.shared === true,
    canView: access?.can_view === true || rank >= ACCESS_RANK.view,
    canComment: access?.can_comment === true || rank >= ACCESS_RANK.comment,
    canEdit: access?.can_edit === true || rank >= ACCESS_RANK.edit,
    canManage: access?.can_manage === true,
  };
};

export const kanbanAccessErrorKey = error => {
  const status = error?.response?.status;
  if (status === 403) return 'KANBAN_SHARING.ERRORS.REVOKED';
  if (status === 404) return 'KANBAN_SHARING.ERRORS.NOT_FOUND';
  return 'KANBAN_SHARING.ERRORS.LOAD';
};
